import MoreVertIcon from '@mui/icons-material/MoreVert';
import {MouseEvent} from 'react';
import {Stack} from '@mui/material';

import {NOTIFICATION_TABS} from '../constants/notifications.constants';
import {NotificationType} from '../types/notifications.types';
import {
  HeaderActionsButton,
  NewCountBubble,
  NotificationTab,
  NotificationTabs,
  NotificationsHeader as NotificationsHeaderRoot,
  NotificationsTitle,
  NotificationsTitleRow,
} from './notifications.styles';

interface NotificationsHeaderProps {
  onOpenBulkActions: (event: MouseEvent<HTMLElement>) => void;
  selectedTab: NotificationType;
  newNotificationsCount: number;
  onSelectTab: (selectedTab: NotificationType) => void;
}

export const NotificationsHeader = ({
  onOpenBulkActions,
  selectedTab,
  newNotificationsCount,
  onSelectTab,
}: NotificationsHeaderProps) => {
  const handleTabChange = (_: unknown, value: NotificationType) => {
    onSelectTab(value);
  };

  return (
    <NotificationsHeaderRoot>
      <NotificationsTitleRow direction="row" alignItems="flex-start" justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap="6px">
          <NotificationsTitle>Уведомления</NotificationsTitle>
          {!!newNotificationsCount && <NewCountBubble>{newNotificationsCount}</NewCountBubble>}
        </Stack>
        <HeaderActionsButton onClick={onOpenBulkActions} aria-label="Действия с уведомлениями">
          <MoreVertIcon />
        </HeaderActionsButton>
      </NotificationsTitleRow>

      <NotificationTabs value={selectedTab} onChange={handleTabChange}>
        {NOTIFICATION_TABS.map((tab) => (
          <NotificationTab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </NotificationTabs>
    </NotificationsHeaderRoot>
  );
};
